import { useState } from 'react';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';

interface Props {
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

type TipoBusquedaType = '' | 'Generar nueva lista de estrados' | 'Consultar listas de estrados';

export const DialogNuevaListaEstrados = ( { openDialog, handleCloseDialog }: Props ) => {

    const navigate = useNavigate(); 

    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>( '' );  
    
    const handleGenerarListaEstrados = async () => {      

        setLoadingGuardar(true);       

        setTimeout(() => {

            setLoadingGuardar(false); 

            if( tipoBusqueda === 'Generar nueva lista de estrados' ){
                navigate("/tribunal/lista-estrados/generar/");
            }
            else if( tipoBusqueda === 'Consultar listas de estrados' ){
                navigate("/tribunal/lista-estrados/consultar/");
            }

        }, 700);  
               
    }

    const handleCerrarDialog = () => {
        
        setTipoBusqueda('');
        handleCloseDialog();

    }

    return (
        <>

            <Dialog open={ openDialog } maxWidth='md' fullWidth={true} >

                <DialogTitle>Lista de estrados</DialogTitle>
            
                <DialogContent>
                    
                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Seleccione una opción:</FormLabel>
                                <RadioGroup row>                                    
                                   
                                    <FormControlLabel 
                                        label="Generar nueva lista de estrados" 
                                        control={ 
                                            <Radio 
                                                checked={ tipoBusqueda === 'Generar nueva lista de estrados' } 
                                                onChange={ () => setTipoBusqueda('Generar nueva lista de estrados') } 
                                            />
                                        } 
                                    />                            

                                    <FormControlLabel 
                                        label="Consultar listas de estrados" 
                                        control={ 
                                            <Radio 
                                                checked={ tipoBusqueda === 'Consultar listas de estrados' } 
                                                onChange={ () => setTipoBusqueda('Consultar listas de estrados') } 
                                            />
                                        } 
                                    />                                   

                                </RadioGroup>

                            </FormControl>

                        </Grid>          

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>
                    <Button 
                        variant="contained" 
                        loading={ loadingGuardar } 
                        onClick={ handleGenerarListaEstrados }
                        disabled={ tipoBusqueda === '' }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    )
}